import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["buttonVariant"],
      _excluded2 = ["href"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { Link } from '@hub/link';
import { useUniversalHeaderSearch } from '../../components/search/use-universal-header-search';
import { Button } from '@hub/button';
import { jsx as _jsx } from "react/jsx-runtime";
const magicLinkUrls = ['/stores', '/centres'];

const isMagicLinkUrl = url => magicLinkUrls.includes(url);

const MagicLink = _ref => {
  let {
    buttonVariant
  } = _ref,
      linkProps = _objectWithoutProperties(_ref, _excluded);

  const {
    setShowSearch
  } = useUniversalHeaderSearch();

  const handleClick = e => {
    var _linkProps$onClick;

    (_linkProps$onClick = linkProps.onClick) === null || _linkProps$onClick === void 0 ? void 0 : _linkProps$onClick.call(linkProps, e);
    e.preventDefault();

    if (linkProps.href === '/stores') {
      setShowSearch(true, 'stores');
    }

    if (linkProps.href === '/centres') {
      setShowSearch(true, 'centres');
    }
  };

  if (isMagicLinkUrl(linkProps.href)) {
    return /*#__PURE__*/_jsx(Link, _objectSpread(_objectSpread({}, linkProps), {}, {
      as: _ref2 => {
        let {
          href: _href
        } = _ref2,
            props = _objectWithoutProperties(_ref2, _excluded2);

        return /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
          variant: buttonVariant
        }, props), {}, {
          "data-id": "magic-link_index_MagicLink_Button"
        }));
      },
      onClick: handleClick,
      "data-id": "magic-link_index_MagicLink_Link"
    }));
  }

  return /*#__PURE__*/_jsx(Link, _objectSpread(_objectSpread({}, linkProps), {}, {
    "data-id": "magic-link_index_MagicLink_Link"
  }));
};

export default MagicLink;